import {
  getScanners,
  getStatus,
} from 'services/testConnect';
import events from 'lib/events';
import {testConnectSidebarEnabled} from 'features';

class TestConnectStatusService {
  latestTcVersion = '1.4.0.0';
  status = {
    scanErrors: false,
  };

  constructor() {
    if (!testConnectSidebarEnabled) {
      return;
    }

    setTimeout(() => {
      getStatus().then(status => {
        if (status.version) {
          this.timer = setInterval(() => {
            getStatus().then(status => {
              this.status.versionOutOfDate = status.version < this.latestTcVersion;
              this.status.version = status.version;
              this.status.noScannersFound = status.scanners.length === 1;
              this.status.scanners = status.scanners;
              this.status.hasSocket = status.connected;
            }).catch(err => {
              console.log('Error getting status', err);
            }).finally(() => {
              this.publishErrorStatus();
            });
          }, 5000);
        } else {
          // Old version. Get scanner status from getScanners and set it.
          getScanners().then(s => {
            this.status.versionOutOfDate = s.version !== this.latestTcVersion;
            this.status.version = s.version;
            this.status.noScannersFound = s.scanners.length === 1;
            this.status.scanners = s.scanners;
            this.status.hasSocket = s.connected;
          }).catch(err => {
            console.log('Error getting scanners', err);
          }).finally(() => {
            this.publishErrorStatus();
          });
        }
      });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  getStatus = () => {
    return this.status;
  };

  setScanErrors = (err) => {
    this.status.scanErrors = err;
    this.publishErrorStatus();
  };

  publishErrorStatus = () => {
    let hasErrors = this.status.versionOutOfDate ||
      this.status.noScannersFound ||
      !this.status.hasSocket || this.status.scanErrors;

    events.publish('testconnect.hasErrors', hasErrors);
  };
}

let tcStatusService = new TestConnectStatusService();

export default tcStatusService;
